import { keyframes, styled } from '@acko-tech/building-blocks.ui.common';

const fadeIn = keyframes`
    from { opacity: 0; }
    to { opacity: 1; }
`;

const shimmer = keyframes`
    0% { background-position: -240px 0; }
    100% { background-position: 240px 0; }
`;

export const TableWrapper = styled.div`
    width: 100%;
    margin-top: 14px;
    border-radius: 10px;
    overflow-x: auto;
    overflow-y: hidden;
    background: #ffffff;
    animation: ${fadeIn} 0.3s ease;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;

    @media screen and (max-width: 768px) {
        min-width: 560px;
    }
`;

export const TableHeaderRow = styled.tr`
    background: #f5f5f5;
`;

export const TableHeaderCell = styled.th`
    padding: 14px 14px 14px 24px;
    color: #5c5c6f;
    font-size: 16px;
    font-weight: 600;
    text-align: left;

    &:first-child {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
    }

    &:last-child {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
    }
`;

export const TableBodyCell = styled.td`
    padding: 14px 20px 14px 24px;
    color: #5d4aa8;
    font-size: 15px;
    text-align: left;
`;

export const TableBodyRow = styled.tr`
    background: #ffffff;
    border-bottom: 1px solid #efefef;
`;

export const TableBodyCellStrong = styled(TableBodyCell)`
    font-weight: 700;
`;

export const TableBodyCellMuted = styled(TableBodyCell)`
    color: #7c7c8b;
`;

type AmountVariant = 'positive' | 'negative' | 'zero';

export const TableBodyCellAmount = styled(TableBodyCell)<{
    variant: AmountVariant;
}>`
    color: ${({ variant }) =>
        variant === 'positive'
            ? '#0b7a6f'
            : variant === 'negative'
            ? '#c45b5b'
            : '#2f2e38'};
    font-weight: 400;
`;

export const TableBodyCellBalance = styled(TableBodyCell)`
    color: #2f2e38;
    font-weight: 400;
`;

export const MobileWrapper = styled.div`
    width: 100%;
    margin-top: 12px;
    animation: ${fadeIn} 0.3s ease;
`;

export const MobileTitle = styled.div`
    color: #1f1e2f;
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 8px;
`;

export const MobileItem = styled.div`
    padding: 10px 0;
    border-bottom: 1px solid #ececf2;
`;

export const MobileTopRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const MobileBottomRow = styled.div`
    margin-top: 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const MobileCategoriesRow = styled.div`
    margin-top: 6px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
`;

export const MobileCategory = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
`;

export const MobileCategoryLabel = styled.div`
    color: #8f8f9f;
    font-size: 12px;
`;

export const MobileDate = styled.div`
    color: #1f1e2f;
    font-size: 18px;
    font-weight: 700;
`;

export const MobileType = styled.div`
    color: #8f8f9f;
    font-size: 14px;
`;

export const MobileBalance = styled.div`
    color: #9e9eab;
    font-size: 14px;
`;

export const TableSkeletonWrapper = styled.div`
    width: 100%;
    margin-top: 14px;
    border-radius: 10px;
    background: #ffffff;
    padding: 12px;
`;

export const SkeletonBlock = styled.div`
    height: 16px;
    border-radius: 6px;
    margin-bottom: 10px;
    background: linear-gradient(90deg, #f2f2f5 25%, #ececf2 50%, #f2f2f5 75%);
    background-size: 240px 100%;
    animation: ${shimmer} 1.2s infinite;
`;
